var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.933 8.784h5.073v1.421H5.813v1.358h3.003v1.42H5.813v1.67h3.3v1.421h-5.18v-7.29zm11.03 1.992v1.328q-.561-.234-1.084-.351-.522-.117-.986-.117-.498 0-.742.127-.24.122-.24.38 0 .21.181.323.186.112.66.166l.307.044q1.343.17 1.807.561.464.39.464 1.226 0 .874-.645 1.313-.644.44-1.924.44-.542 0-1.123-.088-.576-.083-1.186-.254v-1.328q.522.254 1.069.38.552.128 1.118.128.513 0 .772-.142.258-.142.258-.42 0-.234-.18-.347-.176-.117-.708-.18l-.308-.04q-1.167-.146-1.636-.541-.468-.396-.468-1.202 0-.869.595-1.289.596-.42 1.827-.42.483 0 1.015.073.532.073 1.157.23zm6.104 0v1.426q-.357-.244-.718-.361-.356-.117-.742-.117-.732 0-1.143.43-.405.424-.405 1.19 0 .767.405 1.197.41.425 1.143.425.41 0 .776-.122.371-.122.684-.362v1.431q-.41.151-.835.225-.42.078-.845.078-1.48 0-2.314-.757-.835-.762-.835-2.114 0-1.353.835-2.11.835-.762 2.314-.762.43 0 .845.078.42.073.835.225z",
    fontWeight: 700,
    fontSize: 10,
    fontFamily: "DejaVu Sans",
    letterSpacing: 0,
    wordSpacing: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsc);
export default __webpack_public_path__ + "static/media/esc.a0252cfa408202c0f3483fd6705969be.svg";
export { ForwardRef as ReactComponent };